import { Avatar, AvatarFallback } from '@bnsn/ui/components/avatar'
import { BnsnLogoColorWithText } from '@bnsn/ui/atoms'

export const StrategistChatBnsnAvatar = () => {
  return (
    <Avatar className="h-6 w-6">
      <AvatarFallback className="flex items-center justify-center bg-muted text-foreground">
        <BnsnLogoColorWithText width={20} height={20} showText={false} />
      </AvatarFallback>
    </Avatar>
  )
}
